import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-eb3566c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "b-step1-detail-wrapper" }
const _hoisted_2 = { class: "item" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "复核工商注册名称：", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"margin-bottom":"12px"} }, [
  /*#__PURE__*/_createElementVNode("span", { class: "star" }, "*"),
  /*#__PURE__*/_createTextVNode("分子公司工商设立/变更申请表 ")
], -1))

import { ref, withDefaults, watch } from "vue";
import Image from "@/components/Image.vue";
import { File } from "@/types/procss";


export default /*#__PURE__*/_defineComponent({
  props: {
    detail: { default: () => {
      return {
        PageData: {},
        PageFiles: [],
      };
    } }
  },
  setup(__props: any) {

const props = __props as { detail: {
      PageData?: { GsReviewBusRegisterName?: string };
      PageFiles?: File[];
    } }


const GsReviewBusRegisterName = ref<string>("");
const uploadList = ref<{ FileName: string; FileUrl: string }[]>([]);

watch(
  () => props.detail,
  (val) => {
    GsReviewBusRegisterName.value = val.PageData?.GsReviewBusRegisterName || "";
    uploadList.value = val.PageFiles || [];
  },
  {
    deep: true,
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, [
      _hoisted_3,
      _createTextVNode(_toDisplayString(__props.detail.PageData?.GsReviewBusRegisterName || ""), 1)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.detail.PageFiles, (item, index) => {
      return (_openBlock(), _createElementBlock("div", { key: index }, [
        _hoisted_4,
        (_openBlock(), _createBlock(Image, {
          value: item.FileUrl,
          "disable-close": true,
          key: index,
          "download-link": {
          filename: '分子公司工商设立/变更申请表.docx',
          fileKey: '5011',
        }
        }, null, 8, ["value", "download-link"]))
      ]))
    }), 128))
  ]))
}
}

})